<script setup lang="ts">
import { shallowRef, watchEffect } from 'vue';
import router from '@/router/router';
import { useAuthStore } from '@/store/auth-store';
import i18n from '@/localisation/i18n';

const props = defineProps<{ ticket: string }>();

const authStore = useAuthStore();

const authenticationAlertType = shallowRef<null | 'error' | 'info'>(null);
const authenticationTitle = shallowRef<null | string>(null);
const authenticationMessage = shallowRef<null | string>(null);

watchEffect(async () => {
  authenticationMessage.value = null;
  const result = await authStore.loginWithSAMLTicket(props.ticket);

  if (result.success) {
    await router.replace({ name: 'dashboard' });
    return;
  } else if (result.error === 'rest.UserNotApproved') {
    authenticationAlertType.value = 'info';
    authenticationTitle.value = 'Account Approval Pending';
  } else {
    authenticationAlertType.value = 'error';
    authenticationTitle.value = 'Single sign-on failed';
  }

  authenticationMessage.value = i18n.t(result.error, result.details) as string;
});
</script>

<template>
  <VContainer class="flex-column justify-center fill-height">
    <VAlert
      v-if="authenticationTitle && authenticationMessage"
      dense
      :type="authenticationAlertType"
    >
      <h3>{{ authenticationTitle }}</h3>
      {{ authenticationMessage }}
    </VAlert>
    <template v-else>
      <VProgressCircular color="primary" indeterminate :size="200" />
      <h3 class="mt-4">Signing in...</h3>
    </template>
  </VContainer>
</template>
